import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  number: number;
  modelConfigId: number;
  defaultConfig: any;
}

const initialState: InitStata = {
  number: 0,
  modelConfigId: -1,
  defaultConfig: undefined,
};

const customerSlice = createSlice({
  name: 'youth',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    changeCurModelId: (state = initialState, action: PayloadAction<number>) => {
      state.modelConfigId	 = action.payload;
    },
    changeDefaultConfig: (state = initialState, action: PayloadAction<number>) => {
      state.defaultConfig	 = action.payload;
    },
  },
});

// 导出action
export const {
  changeCount,
  changeCurModelId,
  changeDefaultConfig
} = customerSlice.actions;

export default customerSlice.reducer;
